/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useCallback, useState } from 'react';

import { toast } from 'react-toastify';

import { Layout } from '~/components';
import * as Page from '~/pages';

import { ControlPanel } from '../ControlPanel';

import { Container, Sidebar, Wrapper } from './styles';

// type Props = {};

// const TrainingDivision = (props: Props) => {
const TrainingDivision = () => {
  const [lockNextScreen, setLockNextScreen] = useState(true);
  const [selectedComponent, setSelectedComponent] = useState('prescription');

  const sidebarList = [
    {
      value: 'prescription',
      title: 'Prescrições',
    },
    {
      value: 'controlPanel',
      title: 'Painel de controle',
    },
  ];

  function lockScreen(value: boolean) {
    setLockNextScreen(value);
  }

  const sidebarSelectedComponent: { [key: string]: JSX.Element } = {
    controlPanel: <ControlPanel />,
    // prescription: <Page.Professional.PrescriptionScreen />,
    prescription: <></>,
  };

  const handleTabChange = useCallback(
    (value: string) => {
      // lockNextScreen && value === 'prescription'
      //   ? toast.error('Selecione um grupo muscular antes de prosseguir!')
      //   : setSelectedComponent(value);
      setSelectedComponent(value);
    },
    [lockNextScreen],
  );

  return (
    <Layout title="Aluno">
      <Container>
        <Sidebar>
          <ul>
            {sidebarList.map((item) => (
              <li
                key={item.value}
                onClick={() => handleTabChange(item.value)}
                className={selectedComponent === item.value ? 'active' : ''}
              >
                <p>{item.title}</p>
              </li>
            ))}
          </ul>
        </Sidebar>
        <Wrapper>{sidebarSelectedComponent[selectedComponent]}</Wrapper>
      </Container>
    </Layout>
  );
};

export default TrainingDivision;
